export enum ReplenishmentCarrierAccountLoader {
  FetchCarrierLoader = "replenishment.carrierAccount.fetchCarrierLoader",
  CarrierModalButtonLoader = "replenishment.carrierAccount.carrierModalButtonLoader",
}
